module.exports = __webpack_public_path__ + "img/KE.48f6ca22.png";